import { render, staticRenderFns } from "./mktHtmlTextarea.vue?vue&type=template&id=4f70ca93&"
import script from "./mktHtmlTextarea.vue?vue&type=script&lang=js&"
export * from "./mktHtmlTextarea.vue?vue&type=script&lang=js&"
import style0 from "./mktHtmlTextarea.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports